module.exports = __webpack_public_path__ + "img/fake-user-7.175ac0a5.png";